"use strict";

import { createContext } from 'react';
export const DisplayModeContext = /*#__PURE__*/createContext({
  mode: 'AM',
  setMode: () => {}
});
//# sourceMappingURL=DisplayModeContext.js.map